import { DOCS_URL } from "../../../config/constants.js";
import { ETitleFontSizes } from "../../../config/enums.js";
import ClientLogos from "./ClientLogos.svelte";

export default {
    component: ClientLogos,
    name: "ClientLogos",
    description: "Display client/partner logos in a grid layout",
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/building-store.svg",
    docsLink: `${DOCS_URL}/storybook/?path=/docs/atoms-clientlogos--docs`,
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2F4592bb64d96b476496c9953e328bcae1",
    inputs: [
        {
            friendlyName: "Title",
            name: "title",
            type: "text",
            required: true,
        },
        {
            friendlyName: "Heading Level (Semantic)",
            name: "headingLevel",
            type: "text",
            enum: ["h1", "h2", "h3", "h4", "h5", "h6"],
            defaultValue: "h2",
            helperText: "Select the semantic HTML heading level for SEO and accessibility",
            showIf: `options.get('title') !== ''`,
        },
        {
            friendlyName: "Title Font Size",
            name: "titleSize",
            type: "text",
            enum: Object.values(ETitleFontSizes),
            defaultValue: ETitleFontSizes.H2,
            showIf: `options.get('title') !== ''`,
        },
        {
            friendlyName: "CTA Text",
            name: "linkText",
            type: "string",
        },
        {
            friendlyName: "CTA Link",
            name: "linkUrl",
            type: "string",
        },
        {
            friendlyName: "Clients",
            name: "clients",
            type: "list",
            subFields: [
                {
                    friendlyName: "Name",
                    name: "name",
                    type: "text",
                    required: true,
                },
                // ImageInputsTemplate <-- see this template
                {
                    friendlyName: "Logo",
                    name: "image",
                    type: "object",
                    helperText: "Any Aspect Ratio",
                    subFields: [
                        {
                            friendlyName: "Source",
                            name: "src",
                            type: "file",
                            allowedFileTypes: ["jpg", "webm", "gif", "png"],
                            defaultValue: "https://placehold.co/400",
                            required: true,
                        },
                        {
                            friendlyName: "Alt",
                            name: "alt",
                            type: "text",
                        },
                    ],
                },
            ],
        },
    ],
};
